module.exports = __webpack_public_path__ + "img/chat-new-chat@3x.9389df2d.png";